import { useEffect, useRef, useState } from 'react';
import { useInForeground } from '../../../../../utils/useInForeground';
export const useForegroundPauseRef = ({ isPlaying, play, pause, }) => {
    const ref = useRef();
    const inForeground = useInForeground(ref);
    const [wasPlaying, setWasPlaying] = useState(false);
    useEffect(() => {
        if (!inForeground && isPlaying) {
            pause();
            setWasPlaying(true);
        }
        if (inForeground && wasPlaying) {
            play();
            setWasPlaying(false);
        }
    }, [pause, play, isPlaying, inForeground, wasPlaying]);
    return ref;
};
//# sourceMappingURL=useForegroundPauseRef.js.map